export const REQUIREMENTS = {
  EXCEPTIONAL_CREDIT: "exceptionalCredit",
  LETTER_OF_EMPLOYMENT: "letterOfEmployment",
  PAST_REFERENCES: "pastReferences",
  NO_SMOKING: "noSmoking",
  PHOTO_ID: "photoId"
}

export const Requirements = [
  { name: "Credit Check", value: REQUIREMENTS.EXCEPTIONAL_CREDIT },
  { name: "Proof of Income", value: REQUIREMENTS.LETTER_OF_EMPLOYMENT },
  { name: "Landlord Reference", value: REQUIREMENTS.PAST_REFERENCES },
  { name: "No Smoking", value: REQUIREMENTS.NO_SMOKING },
  { name: "Photo ID", value: REQUIREMENTS.PHOTO_ID },

]
